import React, { useState } from "react"
import VLCCProcTab from "./Components/VLCCProcTab"
import CCProcTab from "./Components/CCProcTab"
import VLCCSalesTab from "./Components/VLCCSalesTab"

const TABS = ["VLCC Procurement Summary", "CC Procurement Summary", "VLCC Sales Summary"]

const ProcurementSummary = () => {
  const [tab, setTab] = useState(0)
  return (
    <>
      <div className="incentivePanel">
        {TABS.map((t, i) => (
          <span key={i} onClick={() => setTab(i)} className={tab === i ? "acActive" : ""} style={{ cursor: "pointer" }}>{t}</span>
        ))}
      </div>
      <div style={{ marginTop: "10px" }}>
        {tab === 0 && <VLCCProcTab />}
        {tab === 1 && <CCProcTab />}
        {tab === 2 && <VLCCSalesTab />}
      </div>
    </>
  )
}
export default ProcurementSummary
